function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "bxs-edit",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_11885",
  "data-name": "Path 11885",
  d: "M28.551,3.018l4.59,4.59-3.5,3.5-4.59-4.59Z",
  transform: "translate(-4.087 -3.018)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11886",
  "data-name": "Path 11886",
  d: "M12,24.31h4.59L27.741,13.159l-4.59-4.59L12,19.72Z",
  transform: "translate(-4.349 -2.906)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11887",
  "data-name": "Path 11887",
  d: "M28.982,28.982H12.392c-.04,0-.082.015-.12.015s-.1-.013-.153-.015H7.56V7.56H18.038L21.1,4.5H7.56A3.062,3.062,0,0,0,4.5,7.56V28.982a3.062,3.062,0,0,0,3.06,3.06H28.982a3.06,3.06,0,0,0,3.06-3.06V15.719l-3.06,3.06Z",
  transform: "translate(-4.5 -2.988)",
  fill: "#ac1ede"
}));

var SvgBxsEdit = function SvgBxsEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29.054,
    height: 29.054,
    viewBox: "0 0 29.054 29.054",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBxsEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bxs-edit.f2804423.svg";
export { ForwardRef as ReactComponent };